import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import Home from "./Home";
import { ToastContainer } from "react-toastify";
import ScrollToTopButton from "./ScrollToTopButton";
import { FaInstagram, FaLinkedinIn, FaGithub } from "react-icons/fa";

const Main = () => {
    const location = useLocation();

    return (
        <>
            <NavBar />

            {/* Render Home only on the root path */}
            {location.pathname === "/" && <Home />}

            {/* Nested routes render here */}
            <div className="pt-[5.5rem]">
                <Outlet />
            </div>

            <ToastContainer position="top-center" autoClose={3000} theme="dark" style={{ zIndex: 9999 }} />
            <Footer />
            <ScrollToTopButton
                style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    marginBottom: "10px",
                    backgroundColor: "rgb(1, 1, 56)",
                }}
            />

            {/* Floating social buttons */}
            <div className="z-600 lg:flex fixed top-[70%] flex-col">
                <ul>
                    <li className="flex items-center w-[138px] sm:w-[150px] md:w-[145px] h-[50px] justify-around bg-purple-600 ml-[-90px] hover:ml-[0px] duration-300">
                        <a
                            href="https://www.instagram.com/acm_vnrvjiet/"
                            target="_blank"
                            rel="noreferrer"
                            className="flex text-[13.5px] items-center w-[100px] h-[50px] justify-between text-white pl-[5px]"
                        >
                            Instagram
                            <FaInstagram size={20} />
                        </a>
                    </li>

                    <li className="flex items-center w-[138px] sm:w-[150px] md:w-[145px] h-[50px] justify-around bg-blue-600 ml-[-90px] hover:ml-[0px] duration-300">
                        <a
                            href="https://www.linkedin.com/company/acm-vnrvjiet/"
                            target="_blank"
                            rel="noreferrer"
                            className="flex  text-[15px] items-center w-[100px] h-[50px] justify-between text-white pl-[5px]"
                        >
                            LinkedIn
                            <FaLinkedinIn size={20} />
                        </a>
                    </li>

                    <li className="flex items-center w-[138px] sm:w-[150px] md:w-[145px] h-[50px] justify-around bg-gray-600 ml-[-90px] hover:ml-[0px] duration-300">
                        <a
                            href="https://github.com/acmvnrvjiet"
                            target="_blank"
                            rel="noreferrer"
                            className="flex  text-[15px] items-center w-[100px] h-[50px] justify-between text-white pl-[5px]"
                        >
                            GitHub
                            <FaGithub size={20} />
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
};

export default Main;
